import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import BeforeAfterSection from './components/BeforeAfterSection';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import BestExpertsSection from './components/BestExpertsSection';
import SupportSection from './components/SupportSection';
import OurServicesSection from './components/OurServicesSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import ProfessionalAssistanceSection from './components/ProfessionalAssistanceSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TrademarkRegistration from './pages/services/TrademarkRegistration';
import CopyrightRegistration from './pages/services/CopyrightRegistration';
import CompanyFormation from './pages/services/CompanyFormation';
import TrademarkSearch from './pages/services/TrademarkSearch';
import AmazonBrandRegistry from './pages/services/AmazonBrandRegistry';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const open = () => setIsContactFormOpen(true);

  return (
    <div>
      <Header onOpenContactForm={open} />
      <HeroBanner />
      <BeforeAfterSection />
      <WhyNeedSection onOpenContactForm={open} />
      <CTASection
        onOpenContactForm={open}
        imagePosition="right"
        heading="Register Your Trademark Online with Expert Attorneys"
        paragraph="Our trademark attorneys handle every detail of your federal registration. From comprehensive USPTO database searches to application filing and office action responses, we make online trademark registration straightforward and stress-free. Secure your brand name, logo, or slogan with professional legal support starting at $45."
        buttonText="Register Trademark Online"
        imageSrc="https://images.unsplash.com/photo-1774891937400-b5e32f719fae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHx0cmFkZW1hcmslMjBzdGFtcCUyMG9mZmljaWFsJTIwZG9jdW1lbnQlMjBzZWFsfGVufDB8fHx8MTc3NTUwNzQ4OXww&ixlib=rb-4.1.0&q=85"
      />
      <BestExpertsSection onOpenContactForm={open} />
      <CTASection
        onOpenContactForm={open}
        imagePosition="left"
        heading="Amazon Brand Registry | Protect Your Seller Account"
        paragraph="Amazon Brand Registry enrollment starts with a registered trademark. Our attorneys file your trademark specifically to meet Amazon requirements, then guide you through the Brand Registry application process. Unlock A+ Content, Sponsored Brands advertising, and powerful IP protection tools for your Amazon seller business."
        buttonText="Enroll in Brand Registry"
        imageSrc="https://images.unsplash.com/photo-1633174524827-db00a6b7bc74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxhbWF6b24lMjBib3hlcyUyMHdhcmVob3VzZSUyMHNlbGxlcnxlbnwwfHx8fDE3NzU1MDc1MDB8MA&ixlib=rb-4.1.0&q=85"
      />
      <SupportSection />
      <OurServicesSection onOpenContactForm={open} />
      <HowWeWorkSection />
      <PricingSection onOpenContactForm={open} />
      <ProfessionalAssistanceSection />
      <WhyChooseUsSection onOpenContactForm={open} />
      <TestimonialsSection />
      <FAQSection />
      <Footer onOpenContactForm={open} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/services/company-formation" element={<CompanyFormation />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch />} />
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
